const EXAMPLES = [
  {
    industry: 'Roofing',
    icon: 'ri-home-gear-line',
    image: 'https://readdy.ai/api/search-image?query=professional%20roofer%20installing%20shingles%20on%20a%20residential%20home%2C%20bright%20sunny%20day%2C%20clean%20suburban%20neighborhood%20background%2C%20warm%20natural%20lighting%2C%20high%20quality%20photorealistic%20image%2C%20simple%20clean%20background%2C%20no%20text%20overlay%2C%20skilled%20tradesman%20at%20work&width=600&height=400&seq=contractor-ex-roofing-01&orientation=landscape',
    hook: 'Your roof is leaking — and every day you wait costs more.',
    headline: 'Free Roof Inspection. Same-Week Repairs.',
    cta: 'Book My Free Inspection',
    platform: 'Facebook',
    platformIcon: 'ri-facebook-circle-fill',
    result: '+340% more inspection bookings',
  },
  {
    industry: 'Landscaping',
    icon: 'ri-plant-line',
    image: 'https://readdy.ai/api/search-image?query=professional%20landscaper%20trimming%20a%20beautiful%20green%20lawn%20in%20a%20well-maintained%20suburban%20backyard%2C%20lush%20grass%20and%20garden%20beds%2C%20warm%20golden%20hour%20lighting%2C%20clean%20simple%20background%2C%20photorealistic%2C%20no%20text%2C%20skilled%20worker%20with%20equipment&width=600&height=400&seq=contractor-ex-landscaping-01&orientation=landscape',
    hook: 'Tired of your yard looking like everyone else\'s?',
    headline: 'Custom Landscaping That Makes Neighbors Jealous.',
    cta: 'Get My Free Quote',
    platform: 'Instagram',
    platformIcon: 'ri-instagram-fill',
    result: '2.8x more quote requests',
  },
  {
    industry: 'General Contracting',
    icon: 'ri-tools-line',
    image: 'https://readdy.ai/api/search-image?query=general%20contractor%20reviewing%20blueprints%20at%20a%20modern%20home%20renovation%20site%2C%20professional%20worker%20in%20hard%20hat%20and%20safety%20vest%2C%20clean%20construction%20environment%2C%20warm%20natural%20lighting%2C%20photorealistic%2C%20no%20text%2C%20confident%20skilled%20tradesman&width=600&height=400&seq=contractor-ex-gc-01&orientation=landscape',
    hook: 'Most contractors ghost you after the estimate. We don\'t.',
    headline: 'Licensed. On-Time. On-Budget. Guaranteed.',
    cta: 'Get a Free Estimate Today',
    platform: 'Google Ads',
    platformIcon: 'ri-google-fill',
    result: '4.1x return on ad spend',
  },
];

export default function ContractorExamples() {
  return (
    <section className="py-20 lg:py-24 bg-stone-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-14">
          <span className="inline-block text-sm font-semibold text-orange-500 uppercase tracking-widest mb-3">
            Real Ad Examples
          </span>
          <h2 className="text-3xl lg:text-4xl font-black text-stone-900 mb-4 leading-tight">
            Industry-Specific Ads That Get Results
          </h2>
          <p className="text-base text-stone-500 max-w-xl mx-auto">
            AdForge knows your trade. Here&apos;s what AI-generated{' '}
            <strong>contractor advertising</strong> looks like for real home service businesses.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-7">
          {EXAMPLES.map((ex) => (
            <article
              key={ex.industry}
              className="bg-white rounded-2xl border border-stone-100 overflow-hidden flex flex-col"
            >
              <div className="relative w-full h-48 overflow-hidden">
                <img
                  src={ex.image}
                  alt={`${ex.industry} ad example`}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute top-3 left-3 flex items-center gap-1.5 bg-white/90 backdrop-blur-sm rounded-full px-3 py-1.5">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className={`${ex.platformIcon} text-sm text-stone-700`} />
                  </div>
                  <span className="text-xs font-semibold text-stone-700">{ex.platform}</span>
                </div>
                <div className="absolute top-3 right-3 flex items-center gap-1.5 bg-orange-500 rounded-full px-3 py-1.5">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className={`${ex.icon} text-xs text-white`} />
                  </div>
                  <span className="text-xs font-bold text-white">{ex.industry}</span>
                </div>
              </div>

              <div className="p-6 flex flex-col gap-3 flex-1">
                <div>
                  <p className="text-xs font-semibold text-stone-400 uppercase tracking-widest mb-1">Hook</p>
                  <p className="text-sm text-stone-700 italic leading-relaxed">&ldquo;{ex.hook}&rdquo;</p>
                </div>
                <div>
                  <p className="text-xs font-semibold text-stone-400 uppercase tracking-widest mb-1">Headline</p>
                  <p className="text-base font-bold text-stone-900 leading-snug">{ex.headline}</p>
                </div>
                <div className="mt-auto pt-4 border-t border-stone-100 flex items-center justify-between">
                  <span className="inline-block px-4 py-2 bg-orange-500 text-white text-xs font-bold rounded-lg whitespace-nowrap">
                    {ex.cta}
                  </span>
                  <span className="text-xs font-semibold text-green-600 bg-green-50 border border-green-100 rounded-full px-3 py-1">
                    {ex.result}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>

        <p className="text-center text-sm text-stone-400 mt-8">
          AdForge also works for plumbers, electricians, HVAC, painters, pressure washers, and more.{' '}
          <a href="/signup" className="text-orange-500 font-semibold hover:underline">Try it free →</a>
        </p>
      </div>
    </section>
  );
}
